import React from "react";

interface Props {
  dueInDays: number;
}

export const DocumentV1Term = (props: Props) => {
  const { dueInDays } = props;

  return (
    <div>
      {dueInDays === 1 ? RESX.DateTime.YDay : `${dueInDays} ${RESX.DateTime.days}`}
    </div>
  );
};

